<template>
  <div class="container banner">

    <div class="swiper-container">
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div class="swiper-slide" v-for="(i, index) in data" :key="index">
          <div class="slide-inner"><img :src="imgurl + i.image" alt="">
            <div class="container top"></div>
            <div class="content">
              <div class="content-title">{{ i.title }}</div>
              <div class="content-text">{{ i.titles }}</div>
              <div class="content-more" @click="click(i)">了解更多</div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-button-prev">
        <img src="../../img/zuo.svg" alt="">
        <img src="../../img/zuoliang.svg" alt="">
      </div>
      <div class="swiper-button-next">
        <img src="../../img/you.svg" alt="">
        <img src="../../img/youliang.svg" alt="">
      </div>

      <!-- 如果需要滚动条 -->
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { home } from '../../request/api';

export default {
  data() {
    return {
      dataList: [
        require('../../img/banner.png'),
        "https://i1.mifile.cn/a4/xmad_15532384207972_iJXSx.jpg",
        "https://i1.mifile.cn/a4/xmad_15517939170939_oiXCK.jpg",
      ],
      data: [],
      imgurl: 'https://admin.zxbiotech.cn',
    };
  },
  watch: {
    bannerList: {
      handler() {
        this.$nextTick(function () {
          new Swiper(".swiper-container", {});
        });
      }
    }
  },

  created() {

  },
  mounted() {
    home().then((res) => {
      this.data = res.data.data.banner
      this.$nextTick(() => {
        var interleaveOffset = 0.5;
        new Swiper(".swiper-container", {
          loop: true,
          speed: 1000,
          grabCursor: true,
          watchSlidesProgress: true,
          mousewheelControl: true,
          keyboardControl: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          on: {
            progress: function () {
              var swiper = this;

              for (var i = 0; i < swiper.slides.length; i++) {
                var slideProgress = swiper.slides[i].progress;
                var innerOffset = swiper.width * interleaveOffset;
                var innerTranslate = slideProgress * innerOffset;
                swiper.slides[i].querySelector(".slide-inner").style.transform =
                  "translate3d(" + innerTranslate + "px, 0, 0)";
              }
            },
            touchStart: function () {
              var swiper = this;
              for (var i = 0; i < swiper.slides.length; i++) {
                swiper.slides[i].style.transition = "";
              }
            },
            setTransition: function (speed) {
              var swiper = this;
              for (var i = 0; i < swiper.slides.length; i++) {
                swiper.slides[i].style.transition = speed + "ms";
                swiper.slides[i].querySelector(".slide-inner").style.transition =
                  speed + "ms";
              }
            }
          }
        });
      })

    });
  },
  methods: {
    click(i) {
      if (i.url) window.location.href = i.url;
    }
  },
};
</script>

<style scoped>
@media screen and (min-width: 300px) and (max-width: 820px) {
  .slide-inner img {
    object-fit: cover;
  }

  .swiper-container-horizontal>>>.swiper-pagination-bullets {
    width: auto !important;
    left: auto !important;
    right: 20px !important;
  }

  .swiper-container-horizontal>>>.swiper-pagination-bullet {
    width: 30px !important;

  }

  .content {
    height: 100%;
    width: 100%;
    left: 0 !important;
    bottom: 0 !important;
    padding-top: 220px;
    box-sizing: border-box;
  }

  .content-more {
    width: 96px !important;
    font-size: 14px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
    box-sizing: content-box;
    margin: 0 auto;
    border-radius: 30px !important;
  }

  .content-text {
    font-size: 32px !important;
    margin: 0 auto;
    width: 290px;
    align-items: center;
  }

  .content-title {
    font-size: 32px !important;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }

  .swiper-container-horizontal>>>.swiper-button-prev {
    display: none !important;
  }

  .swiper-container-horizontal>>>.swiper-button-next {
    display: none !important;
  }
}

.slide-inner {
  height: 100%;
  width: 100%;
}

.content {
  position: absolute;
  left: 3.25rem;
  bottom: 3.6rem;
  z-index: 200;
}

.swiper-slide {
  overflow: hidden;
}

.content-title {
  font-size: 0.56rem;
  font-family: 'Alibaba PuHuiTi-Regular';
  color: #fff;
}

.content-text {
  font-size: 0.56rem;
  font-family: 'Alibaba PuHuiTi-Regular';
  color: #fff;
}

.content-more {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.23rem;
  font-family: 'Alibaba PuHuiTi-Regular';
  font-weight: 400;
  color: #FFFFFF;
  padding-top: 0.21rem;
  padding-bottom: 0.21rem;
  padding-left: 0.56rem;
  padding-right: 0.56rem;
  border-radius: 0.38rem 0.38rem 0.38rem 0.38rem;
  border: 1px solid #FFFFFF;
  width: 2rem;
  margin-top: 0.79rem;
}

.content-more:hover {
  cursor: pointer;
}

.swiper-container-horizontal>>>.swiper-button-prev {
  z-index: 200;
  right: 3.93rem;
  bottom: 1.18rem;
  top: auto;
  left: auto
}

.swiper-container-horizontal>>>.swiper-button-next {
  z-index: 200;
  right: 3.26rem;
  bottom: 1.18rem;
  top: auto;
}

.swiper-container-horizontal>>>.swiper-button-next img:nth-child(2) {
  display: none;
}

.swiper-container-horizontal>>>.swiper-button-prev img:nth-child(2) {
  display: none;
}

.swiper-container-horizontal>>>.swiper-button-next:hover img:nth-child(1) {
  display: none;
}

.swiper-container-horizontal>>>.swiper-button-next:hover img:nth-child(2) {
  display: block;
}

.swiper-container-horizontal>>>.swiper-button-prev:hover img:nth-child(1) {
  display: none;
}

.swiper-container-horizontal>>>.swiper-button-prev:after {
  content: "";
}

.swiper-container-horizontal>>>.swiper-button-next:after {
  content: "";
}

.swiper-container-horizontal>>>.swiper-button-prev:hover img:nth-child(2) {
  display: block;
}

.swiper-container-horizontal>>>.swiper-pagination-bullets {
  bottom: 1.43rem;
  left: 3.25rem;
}

.swiper-container-horizontal>>>.swiper-pagination-bullet {
  width: 0.5rem;
  border-radius: 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.40);
}

.swiper-container-horizontal>>>.swiper-pagination-bullet-active {
  background: #fff;
}

.swiper-container-horizontal>>>.swiper-pagination {
  text-align: start;
  z-index: 200;
}

.swiper-container-horizontal>>>.swiper-button-prev {}

.swiper-container {
  width: 100%;
  height: 100%;
  z-index: 100;
  position: absolute;
}

img {
  width: 110%;
  height: 100%;
}

.banner {
  height: 100vh;
}

.img img {
  height: 100%;
  width: 110%;
}

.container {
  position: relative;


}

.lunbo {
  height: 100%;
}

.lunbo .img {
  height: 100%;
}

.doo {
  padding: 0;
}

.doo div {
  width: 0.5rem;
  height: 0.025rem;
  float: left;
  cursor: pointer;
  background: gray;
  margin-right: 0.25rem;
}

.dooted {
  position: absolute;
  bottom: 2rem;
  left: 3.25rem;
}

.text {
  position: absolute;
  left: 3.25rem;
  color: #fff;
  top: 5.3625rem;
  font-size: 0.5625rem;
  font-weight: 400;

}

.text-t {
  font-family: "Alibaba PuHuiTi-Regular";
}

.text-b {
  font-family: "Alibaba PuHuiTi-Regular";
}

.more {
  border-radius: 0.7375rem;
  border: solid 1px #fff;
  height: 0.7375rem;
  width: 2rem;
  position: absolute;
  left: 3.25rem;
  bottom: 3.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 0.225rem;
}

.current {
  background-color: #fff !important;
}

.turn {
  width: 1rem;
  height: 1rem;
  line-height: 20px;
  border-radius: 5px;
  cursor: pointer;
}

.right {
  position: absolute;
  top: 10.45rem;
  right: 3.2625rem;
  height: 0.4875rem;
  width: 0.4875rem;
  transform: rotate(180deg);
}

.left {
  position: absolute;
  top: 10.45rem;
  right: 3.9225rem;
  height: 0.4875rem;
  width: 0.4875rem;
}

.current {
  color: gray;
}

.top {
  background: linear-gradient(360deg, #03091E 0%, rgba(3, 9, 30, 0.83) 29%, rgba(3, 9, 30, 0.34) 75%, rgba(3, 9, 30, 0) 100%);
  position: absolute;
  bottom: 0;
  left: 0;
  height: 8.18rem;
  width: 100%;
  z-index: 150;
  pointer-events: ;
}
</style>



// WEBPACK FOOTER //
// src/components/main/main.vue